<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt/>
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt/>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="title">{{ model.title }}</div>
      <div class="priceBox">
        <span
          class="span"
        >晚宴时间：{{ model.tablePartyTimeStart }} ~ {{ model.tablePartyTimeEnd }}</span>
        <span class="span">晚宴地点：{{ model.tablePartyLocation }}</span>
      </div>
    </div>
    <div class="sign" :model="model">
      <div class="img">
        <img :src="model.thumbApp" alt="">
      </div>
      <div class="input">
        <input v-model="model.phoneNumber" type="text" placeholder="请输入电话号码" @input="handleInput">
      </div>
			<div class="radio">
				<div v-for="(item, index) in userList" :class="{'checked': item.checked}" @click="check(item, index)">
					<span>{{item.name}}</span>
				</div>
			</div>
      <div class="btn">
        <button @click="btn">晚宴签到</button>
      </div>
    </div>

		<div class="popup" v-if="showPopup">
			<div class="box">
				<div class="bg-top">
					<div class="date">
						<p>{{monthDate}}</p>
						<p>{{time}}</p>
					</div>
				</div>
				<div class="bg-bottom">
					<div class="blank">
						<div class="sign-item" v-for="item in signedList">
							<div class="sign-row">
								<div class="sign-label">
									<p>签到人</p>
									<p>{{item.name}}</p>
								</div>
								<div class="sign-label">
									<p>职位</p>
									<p>{{item.companyDuty}}</p>
								</div>
								<div class="sign-label">
									<p>晚宴座位</p>
									<p>{{item.tableSort}}号桌{{item.seatSort}}座</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<img src="../../src/assets/img/ic_close_circle.svg" width="32" alt="" @click="close">
			</div>
		</div>

		<div class="parentBox" v-if="loading">
			<div class="contantBox"></div>
			<div>加载中...</div>
		</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  components: {
  },
  data () {
    return {
      model: {},
      userList: [],
      signedList: [],
      showPopup: false,
      monthDate: moment().format('MM月DD日'),
      time: '',
      interval: null,
      loading: false
    }
  },
  created () {
    this.content()
  },
  methods: {
    check (item, index) {
      this.userList[index].checked = !this.userList[index].checked
      this.userList = [...this.userList]
    },
    content () {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.params.contentId}`, {})
        .then(res => {
          if (res.code == 200) {
            this.model = res.data
          }
        })
    },
    handleInput (e) {
      let value = e.target.value
      let reg = /^\d{11}$/
      let patt = /^[1][3-9][\d]{9}/
      if (reg.test(value) && patt.test(value)) {
        const param = {
				  conferenceId: this.$route.query.contentId,
				  phoneNumber: this.model.phoneNumber
        }
        this.$axios
          .post(`/api/web/phone/conference/partyAttendee?contentId=${this.$route.params.contentId}&phoneNumber=${this.model.phoneNumber}`, {})
          .then(res => {
            if (res.code == 200) {
              this.userList = res.data
            }
          })
      }
    },
    btn () {
      if (this.model.phoneNumber == '' || this.model.phoneNumber == undefined) {
        this.MessageBox.alert('请输入电话号码').then(action => {
        })
        return
      }
      let reg = /^\d{11}$/
      let patt = /^[1][3-9][\d]{9}/
      if (!(reg.test(this.model.phoneNumber) && patt.test(this.model.phoneNumber))) {
        this.MessageBox.alert('请输入正确格式的电话号码').then(action => {})
        return
      }
      //  if (this.userList.length == 0) {
			  // this.MessageBox.alert('此手机号码尚未报名晚宴').then(action => {
			  // })
			  // return
      //  }

      const checkedArr = this.userList.filter(el => el.checked)
      let attendeeIdList = []
      if (checkedArr.length == 0) {
        attendeeIdList = this.userList.map(el => { return el.id })
      } else {
        attendeeIdList = checkedArr.map(el => { return el.id })
      }
      if (attendeeIdList.length == 0) {
        this.MessageBox.alert('未选择签到人员或签到人员未付款').then(action => {})
        return
      }
      this.time = moment().format('HH:mm:ss')
      this.loading = true
      this.$axios
			  .postJson('/api/web/phone/conference/partyAttendeeSign', {
          attendeeIdList: attendeeIdList,
          contentId: this.$route.params.contentId
        }).then(res => {
			    if (res.code == 200) {
            this.signedList = res.data
            this.interval = setInterval(() => {
						  this.time = moment().format('HH:mm:ss')
            }, 1000)
            this.showPopup = true
			    }
			  }).finally(() => {
          this.loading = false
        })
    },
    close () {
      clearInterval(this.interval)
      this.showPopup = false
    },
    beforeDestroy () {
      clearInterval(this.interval) // 结束定时器
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #9f9f9f;
  margin: 20px 24px;
  text-align: left;
}

.priceBox {
  position: relative;
}

.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}

.title-bj {
  padding: 26px;
  margin: 22px 12px 0;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
  position: relative;
}

.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}

.title {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}

.sign {
  height: 100%;
  background: #fff;
  border-radius: 10px;
  // z-index: -1;
  margin: -40px 10px;
  padding: 50px 12px 10px;

  .img {
    img {
      width: 100%;
      border-radius: 10px;
    }
  }

  .input {
    text-align: left;
    margin-top: 24px;
    padding: 10px;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }

  .btn {
    left: 32%;
    margin-top: 20%;

    button {
      height: 40px;
      color: #fff;
      background: #F9B21B;
      border: none;
      border-radius: 20px;
      font-size: 14px;
      padding: 0 20px;
    }
  }
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}

/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

.p {
  margin: 9px 10px 0;
  font-size: 12px;
}

.box {
  height: 56px;
}

.body {
  position: fixed;
  width: 100%;
  height: 100%;
  // background-color: #fff;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;

  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;

    img{
      height: 35px;
    }
  }

  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.radio {
  text-align: left;
	margin: 10px 0;

	div {
		height: 28px;
		line-height: 28px;
		// display: flex;
		border: 1px solid #ddd;
		border-radius: 15px;
		padding: 5px 10px;
		margin-bottom: 5px;
		text-align: center;
	}
	input {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	span {
		display: block;
		margin-top: 0;
	}
	.checked {
		color: #fff;
		background: #F9B21B;
	}
}

.popup {
	position: fixed;    /*弹框固定位置不随滚动*/
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.1);
	z-index: 9999;     /*弹框层级高于整个网页*/
	top: 0;
	left: 0;
	.box {
		width: 80%;
		// height: 400px;
		position: fixed;
		top: 27%;
		left: 50%;
		transform: translate(-50%, -50%);
		.bg-top {
			width: 100%;
			height: 128px;
			background: url('../assets/img/img_sign_bg_top.png') no-repeat;
			background-size: 100%;
			// border-radius: 15px 15px 0 0;
			position: relative;
			display: flex;
			align-items: center;
			.date {
				margin: auto;
				p {
					color: #fff;
					font-size: 16px;
				}
				p:last-child {
					font-size: 28px;
					height: 40px;
					line-height: 40px;
				}
			}
		}
		.bg-bottom {
			// width: 100%;
			min-height: 240px;
			background: url('../assets/img/img_sign_bg_bottom.png') no-repeat;
			// background-size: 100%;
			position: relative;
			margin-top: -2px;
			padding-top: 20px;
			.blank {
				background: #fff;
				padding: 0 20px 20px;
				border-radius: 20px;
			}
			.sign-item {
				&:not(:first-child) {
					border-top: 1px dashed #DDDDDD;
					padding-top: 10px;
				}
				.sign-row {
					display: flex;
					justify-content: space-between;
					.sign-label {
						text-align: left;
						p:first-child {
							color: #666666;
							font-size: 12px;
						}
						p:last-child {
							color: #333333;
							font-weight: 500;
							height: 35px;
							line-height: 35px;
						}
					}
				}
			}
		}
		img {
			margin-top: 15px;
		}
	}
}

.parentBox {
	position: fixed;    /*弹框固定位置不随滚动*/
	width: 100%;
	height: 100%;
	z-index: 9999;     /*弹框层级高于整个网页*/
	top: 0;
	left: 0;
  background: rgba(0,0,0,0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	font-size: 13px;
	color: #fff;
  .contantBox {
    width: 60px;
    height: 10px;
    margin-bottom: 5px;
    -webkit-mask: linear-gradient(90deg, #000 70%, #0000 0) 0/20%;
    background: linear-gradient(rgb(249,178,27) 0 0) 0/0% no-repeat #fff;
    animation: cartoon 2s infinite steps(6);
  }

  @keyframes cartoon {
    100% {
      background-size: 120%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dinnerSignin.vue